import { buildQueryParams } from '../../common/auxFun'

const SHOPPING_CART_BASE_ENDPOINT = '/v1/purchases/cart'

const endpointsShoppingCart = {
  CREATE: SHOPPING_CART_BASE_ENDPOINT,
  DUPLICATE: (id) => `${SHOPPING_CART_BASE_ENDPOINT}/${id}/duplicate`,
  LOAD: (filter, sort, limit, skip) =>
    `${SHOPPING_CART_BASE_ENDPOINT}${buildQueryParams({ filter, limit, skip, sort })}`,
  BY_ID: (id) => `${SHOPPING_CART_BASE_ENDPOINT}/${id}`,
  PROVINCES: `${SHOPPING_CART_BASE_ENDPOINT}/provinces`,
}

export default endpointsShoppingCart
